import { jsxs as e, jsx as o } from "react/jsx-runtime";
const s = (l) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...l,
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#google_chrome-colored_svg__a)", children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#google_chrome-colored_svg__b)",
            d: "M22.39 6A12 12 0 0 0 1.605 6l.72 12.96z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#google_chrome-colored_svg__c)",
            d: "M6.804 15 1.608 6A12 12 0 0 0 12 24l11.76-12z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#google_chrome-colored_svg__d)",
            d: "M17.196 15 12 24A12 12 0 0 0 22.39 6H12z"
          }
        ),
        /* @__PURE__ */ o("path", { fill: "#fff", d: "M12 18a6 6 0 1 0 0-12.002A6 6 0 0 0 12 18" }),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "#1A73E8",
            d: "M12 16.752a4.753 4.753 0 1 0 0-9.505 4.753 4.753 0 0 0 0 9.505"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: [
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "google_chrome-colored_svg__b",
            x1: 1.608,
            x2: 22.39,
            y1: 7.5,
            y2: 7.5,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#D93025" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#EA4335" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "google_chrome-colored_svg__c",
            x1: 13.298,
            x2: 2.906,
            y1: 23.249,
            y2: 5.249,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#1E8E3E" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#34A853" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "google_chrome-colored_svg__d",
            x1: 10.248,
            x2: 20.64,
            y1: 24,
            y2: 6.031,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#FCC934" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#FBBC04" })
            ]
          }
        ),
        /* @__PURE__ */ o("clipPath", { id: "google_chrome-colored_svg__a", children: /* @__PURE__ */ o("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
      ] })
    ]
  }
);
export {
  s as default
};
